<template>
  <v-row>
    <v-col cols="12">
        <modifier-ingredient-card></modifier-ingredient-card> 
    </v-col>
  </v-row>
</template>
<script>
import ModifierIngredientCard from "@/components/ingredient/ModifierIngredientCard";

export default {
  metaInfo: {
    // title will be injected into parent titleTemplate
    title: "Modifier Ingredient List",
  },

  components: {
    ModifierIngredientCard
  },

  data() {
    return {
    };
  },
};
</script>